<div class="_client-digicheques-count-component">

	<info-line icon="./assets/icons/info-outline.svg">
		<p>{{'CLIENT.EXTRA.DIGICHEQUES_USED' | translate}}: <b>{{digichequeCount}}</b></p>
	</info-line>
	
</div>